import Vue from 'vue';
import { Datetime } from 'vue-datetime';

export default {
  name: 'dateTimePicker',
  components: {
    datetime: Datetime
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      required: true
    },
    parent: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      val: null,
      arr: [],
      obj: null
    }
  },
  created() {
    this.init();
  },
  watch: {
    val: function (v) {
      this.setDate(v);

      //this.parent.dataObj.generalData.exceptFromPenaltyUntilDateTime = v;

      //console.log(v);
      //console.log(this.obj);
      //console.log('this.parent', this.parent);
    }
  },
  methods: {
    init() {
      this.arr = this.model.split('.');
      this.getObj();
    },
    getObj() {
      var o = this.parent;

      if (this.arr.length == 1)
        this.obj = this.parent[this.arr[0]];
      else if (this.arr.length == 2)
        this.obj = this.parent[this.arr[0]][this.arr[1]];
      else if (this.arr.length == 3)
        this.obj = this.parent[this.arr[0]][this.arr[1]][this.arr[2]];
      else if (this.arr.length == 4)
        this.obj = this.parent[this.arr[0]][this.arr[1]][this.arr[2]][this.arr[3]];
      else if (this.arr.length == 5)
        this.obj = this.parent[this.arr[0]][this.arr[1]][this.arr[2]][this.arr[3]][this.arr[4]];

      this.val = this.obj;
      //for (var i = 0; i < this.arr.length; i++) {
      //  o = this.getSubObj(o, this.arr[i]);
      //}

      //this.obj = Object.keys(this.arr);

      //this.obj = o;
      //this.val = this.obj;
    },
    setDate(value) {
      if (this.arr.length == 1)
        this.parent[this.arr[0]] = value;
      else if (this.arr.length == 2)
        this.parent[this.arr[0]][this.arr[1]] = value;
      else if (this.arr.length == 3)
        this.parent[this.arr[0]][this.arr[1]][this.arr[2]] = value;
      else if (this.arr.length == 4)
        this.parent[this.arr[0]][this.arr[1]][this.arr[2]][this.arr[3]] = value;
      else if (this.arr.length == 5)
        this.parent[this.arr[0]][this.arr[1]][this.arr[2]][this.arr[3]][this.arr[4]] = value;
    },
    getSubObj(obj, subObj) {
      return obj[subObj];
    },
    //setDate(value) {
    //  var o = this.parent;

    //  for (var i = 0; i < this.arr.length; i++) {
    //    o = this.getSubObj(o, this.arr[i]);
    //  }

    //  console.log('o', o);
    //  console.log('value', value);
    //  o = value;
    //}
  }
}

